
interface Scripts {
  name: string;
  src: string;
}
export const Scripts: Scripts[] = [
  { name: 'amchart-core', src: 'https://www.amcharts.com/lib/4/core.js' },
  { name: 'amchart-charts', src: 'https://www.amcharts.com/lib/4/charts.js' },
  { name: 'amchart-animated', src: 'https://www.amcharts.com/lib/4/themes/animated.js' }
];